import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getPatternImages } from '../../../../../helpers/getPatternImages';
import { Shutters63 } from './Shutters63';
import { Shutters76 } from './Shutters76';
import { Shutters89 } from './Shutters89';

export const Shutters = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const {
    custom: { bladeSize },
  } = state.context;
  const patternUrl = getPatternImages(state);

  switch (bladeSize) {
    case '63mm':
      return <Shutters63 patternUrl={patternUrl} {...props} />;
    case '76mm':
      return <Shutters76 patternUrl={patternUrl} {...props} />;
    case '89mm':
    default:
      return <Shutters89 patternUrl={patternUrl} {...props} />;
  }
};
